export default __webpack_public_path__ + "static/faq-6c37745acdf7619a25edc2b746c864e6.png";